import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import * as PropertyActions from '../actions/tourPropertyAction';
import * as tourPropertyService from './../services/tourPropertyService';
import Property from '../models/Property';
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import history from '../helpers/history';

function* getListProperty() {
    yield takeLatest(Types.TOUR_PROPERTY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(tourPropertyService.getProperties, params);
        yield put(PropertyActions.dataPropertySuccess(result));
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* getAllProperty() {
    yield takeLatest(Types.TOUR_PROPERTY_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(tourPropertyService.getAllProperties);
        yield put(PropertyActions.dataAllPropertySuccess(result));
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* getListPropertyAll() {
    yield takeLatest(Types.PROPERTY_LIST_LOAD_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(tourPropertyService.getProperties, params);
        yield put(PropertyActions.dataPropertyLoadAllSuccess(result));
        yield call(getAllData, result, params, tourPropertyService.getProperties, PropertyActions.dataPropertyLoadAllSuccess)
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* getPropertyDetail() {
    yield takeLatest(Types.TOUR_PROPERTY_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(tourPropertyService.getPropertyDetail, action.params.id);
        yield put(PropertyActions.getUpdatePropertySuccess(result));
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* createProperty() {
    yield takeLatest(Types.TOUR_PROPERTY_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const property = (action.params.data)
        yield call(tourPropertyService.createProperty, property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), property.name);
        yield delay(1000)
        history.push(PATHS.TOUR_PROPERTIES.LIST.path);
        history.go();
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* updateProperty() {
    yield takeLatest(Types.TOUR_PROPERTY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const property = (action.params.data);
        const result = yield call(tourPropertyService.updateProperty, property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), property.name);
        yield put({ type: Types.TOUR_PROPERTY_UPDATE_SUCCESS });
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* deleteProperty() {
    yield takeLatest(Types.TOUR_PROPERTY_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(tourPropertyService.deleteProperty, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield delay(SAGA_DELAY_TIMEOUT);
        if(result.status === 204) {
            yield put({ type: Types.TOUR_PROPERTY_LIST_ACTION, filters: action.params.PageIndex })
        }
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

// TRANSLATE
function* createPropertyTranslate() {
    yield takeLatest(Types.TOUR_PROPERTY_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(tourPropertyService.createPropertyTranslate, action.property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.property.translate.languageName);
        yield put({ type: Types.TOUR_PROPERTY_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_PROPERTY_GET_UPDATE_ACTION, params: { id: action.property.id } });
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* updatePropertyTranslate() {
    yield takeLatest(Types.TOUR_PROPERTY_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(tourPropertyService.updatePropertyTranslate, action.property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.property.translate.languageName);
        yield put({ type: Types.TOUR_PROPERTY_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_PROPERTY_GET_UPDATE_ACTION, params: { id: action.property.id } });
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* deletePropertyTranslate() {
    yield takeLatest(Types.TOUR_PROPERTY_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(tourPropertyService.deletePropertyTranslate, action.property.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.property.translate.languageName);
        yield put({ type: Types.TOUR_PROPERTY_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_PROPERTY_GET_UPDATE_ACTION, params: { id: action.refreshParams.id } });
    }, errorHandleProperty(Types.TOUR_PROPERTY_FAIL)))
}

function* getAllData(data = [], params = {}, funcService, funcSetDataCallback) {
    const totalPage = Math.ceil(parseInt(data.totalCount) / parseInt(data.pageSize))
    if(data.result.length > 0 && totalPage > 1) {
        for(let page = 2; page <= totalPage; page++) {
            if(!!funcService && !!funcSetDataCallback && !!params) {
                const nextData = yield call(funcService, { ...params, pageIndex: page });
                yield put(funcSetDataCallback(nextData));
            }
        }
    }
}

function errorHandleProperty(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'property');
}

export function* tourPropertySaga() {
    yield all([
        fork(getListProperty),
        fork(createProperty),
        fork(deleteProperty),
        fork(getPropertyDetail),
        fork(updateProperty),
        fork(getAllProperty),
        fork(createPropertyTranslate),
        fork(updatePropertyTranslate),
        fork(deletePropertyTranslate),
        fork(getListPropertyAll)
    ])
}
